export default __webpack_public_path__ + "static/media/quickbooks_icon.2a9d8ade.jpeg";